import React, { useState, useEffect } from "react";
import { Typography, CircularProgress } from "@mui/material";
import api from "api/api";

const Encountermodal = ({ ismodal, setIsmodal, data = [] }) => {
  const [fetchedImage, setFetchedImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Always use the first encounter in the array
  const currentEncounter = data[0] || {};
  const { title, date, image_links = [] } = currentEncounter;

  useEffect(() => {
    if (image_links.length > 0 && ismodal) {
      fetchImage(image_links[0], 0);
    }
  }, [image_links, ismodal]);


  const fetchImage = async (link, index) => {
    setLoading(true);
    setFetchError(false);
    setActiveIndex(index);
    try {
      const response = await api.get(
        `/v1/patients/document/by-link?document_link=${encodeURIComponent(link)}`
      );

      if (response.success === true && response.data) {
        const mimeType =
          response.data?.mime_type?.split(";")[0] || "image/png";
        const base64 = response.data;
        setFetchedImage(`data:${mimeType};base64,${base64}`);
      } else {
        setFetchError(true);
      }
    } catch (error) {
      console.error("Error fetching image:", error);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  };

  if (!ismodal) return null;

  return (
    <>
      {/* Main Modal */}
      <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
        <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white rounded-lg shadow-lg max-w-2xl w-full p-4 relative">
          {/* Close Button */}
          <button
            onClick={() => {
              setIsmodal(false);
              setFetchedImage("");
              setLoading(false);
              setFetchError(false);
              setActiveIndex(0);
            }}
            className="absolute top-2 right-2 z-10 bg-gray-200 dark:bg-gray-700 rounded-full p-1 hover:bg-red-500 hover:text-white transition"
            aria-label="Close"
          >
            ✕
          </button>

          {/* Heading */}
          <Typography variant="h6" className="mb-1">
  {title
    ? title.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    : ''}
</Typography>

          <Typography variant="subtitle2" className="mb-3 text-gray-600 dark:text-gray-300">
            {date}
          </Typography>

          {/* Image */}
          <div className="flex items-center justify-center border rounded-md bg-gray-100 dark:bg-gray-800 max-h-[70vh] overflow-hidden mb-4">
            {loading ? (
              <div className="min-h-[60vh] flex items-center justify-center">
 <CircularProgress />

              </div>
             
            ) : fetchError ? (
              <Typography color="error">Failed to load image</Typography>
            ) : (
              <img
                src={fetchedImage}
                alt="Encounter document"
                onClick={() => setIsFullScreen(true)}
                className="object-contain max-h-[65vh] w-auto h-auto cursor-zoom-in"
                style={{ maxWidth: "100%" }}
              />
            )}
          </div>

          {/* Page Buttons */}
          <div className="flex gap-2 justify-center overflow-x-auto whitespace-nowrap px-1 py-2">
            {image_links.map((_, index) => (
              <button
                key={index}
                onClick={() => fetchImage(image_links[index], index)}
                className={`text-sm px-3 py-1 rounded font-medium transition-colors duration-200 ${
                  activeIndex === index
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 dark:bg-gray-700 text-blue-600 hover:bg-blue-500 hover:text-white"
                }`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {isFullScreen && (
        <div className="fixed inset-0 z-[999] bg-black bg-opacity-95 flex items-center justify-center p-4">
          <img
            src={fetchedImage}
            alt="Full screen"
            className="object-contain max-w-full max-h-full cursor-zoom-out"
            onClick={() => setIsFullScreen(false)}
          />
          <button
            onClick={() => setIsFullScreen(false)}
            className="absolute top-4 right-4 text-white text-3xl font-bold"
            aria-label="Close fullscreen"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
};

export default Encountermodal;
